class Currency {
    static CURRENCIES = {
        "usd": "United States Dollar",
        "aed": "United Arab Emirates Dirham",
        "afn": "Afghan Afghani",
        "all": "Albanian Lek",
        "amd": "Armenian Dram",
        "ang": "Netherlands Antillean Guilder",
        "aoa": "Angolan Kwanza",
        "ars": "Argentine Peso",
        "aud": "Australian Dollar",
        "awg": "Aruban Florin",
        "azn": "Azerbaijani Manat",
        "bam": "Bosnia and Herzegovina Convertible Mark",
        "bbd": "Barbadian Dollar",
        "bdt": "Bangladeshi Taka",
        "bgn": "Bulgarian Lev",
        "bif": "Burundian Franc",
        "bmd": "Bermudian Dollar",
        "bnd": "Brunei Dollar",
        "bob": "Bolivian Boliviano",
        "brl": "Brazilian Real",
        "bsd": "Bahamian Dollar",
        "bwp": "Botswana Pula",
        "byn": "Belarusian Ruble",
        "bzd": "Belize Dollar",
        "cad": "Canadian Dollar",
        "cdf": "Congolese Franc",
        "chf": "Swiss Franc",
        "clp": "Chilean Peso",
        "cny": "Chinese Yuan",
        "cop": "Colombian Peso",
        "crc": "Costa Rican Colón",
        "cve": "Cape Verdean Escudo",
        "czk": "Czech Koruna",
        "djf": "Djiboutian Franc",
        "dkk": "Danish Krone",
        "dop": "Dominican Peso",
        "dzd": "Algerian Dinar",
        "egp": "Egyptian Pound",
        "etb": "Ethiopian Birr",
        "eur": "Euro",
        "fjd": "Fijian Dollar",
        "fkp": "Falkland Islands Pound",
        "gbp": "British Pound Sterling",
        "gel": "Georgian Lari",
        "gip": "Gibraltar Pound",
        "gmd": "Gambian Dalasi",
        "gnf": "Guinean Franc",
        "gtq": "Guatemalan Quetzal",
        "gyd": "Guyanese Dollar",
        "hkd": "Hong Kong Dollar",
        "hnl": "Honduran Lempira",
        "htg": "Haitian Gourde",
        "huf": "Hungarian Forint",
        "idr": "Indonesian Rupiah",
        "ils": "Israeli New Shekel",
        "inr": "Indian Rupee",
        "isk": "Icelandic Króna",
        "jmd": "Jamaican Dollar",
        "jpy": "Japanese Yen",
        "kes": "Kenyan Shilling",
        "kgs": "Kyrgyzstani Som",
        "khr": "Cambodian Riel",
        "kmf": "Comorian Franc",
        "krw": "South Korean Won",
        "kyd": "Cayman Islands Dollar",
        "kzt": "Kazakhstani Tenge",
        "lak": "Lao Kip",
        "lbp": "Lebanese Pound",
        "lkr": "Sri Lankan Rupee",
        "lrd": "Liberian Dollar",
        "lsl": "Lesotho Loti",
        "mad": "Moroccan Dirham",
        "mdl": "Moldovan Leu",
        "mga": "Malagasy Ariary",
        "mkd": "Macedonian Denar",
        "mmk": "Burmese Kyat",
        "mnt": "Mongolian Tögrög",
        "mop": "Macanese Pataca",
        "mur": "Mauritian Rupee",
        "mvr": "Maldivian Rufiyaa",
        "mwk": "Malawian Kwacha",
        "mxn": "Mexican Peso",
        "myr": "Malaysian Ringgit",
        "mzn": "Mozambican Metical",
        "nad": "Namibian Dollar",
        "ngn": "Nigerian Naira",
        "nio": "Nicaraguan Córdoba",
        "nok": "Norwegian Krone",
        "npr": "Nepalese Rupee",
        "nzd": "New Zealand Dollar",
        "pab": "Panamanian Balboa",
        "pen": "Peruvian Sol",
        "pgk": "Papua New Guinean Kina",
        "php": "Philippine Peso",
        "pkr": "Pakistani Rupee",
        "pln": "Polish Złoty",
        "pyg": "Paraguayan Guaraní",
        "qar": "Qatari Riyal",
        "ron": "Romanian Leu",
        "rsd": "Serbian Dinar",
        "rub": "Russian Ruble",
        "rwf": "Rwandan Franc",
        "sar": "Saudi Riyal",
        "sbd": "Solomon Islands Dollar",
        "scr": "Seychellois Rupee",
        "sek": "Swedish Krona",
        "sgd": "Singapore Dollar",
        "shp": "Saint Helena Pound",
        "sle": "Sierra Leonean Leone",
        "sos": "Somali Shilling",
        "srd": "Surinamese Dollar",
        "std": "São Tomé and Príncipe Dobra",
        "szl": "Swazi Lilangeni",
        "thb": "Thai Baht",
        "tjs": "Tajikistani Somoni",
        "top": "Tongan Pa'anga",
        "try": "Turkish Lira",
        "ttd": "Trinidad and Tobago Dollar",
        "twd": "New Taiwan Dollar",
        "tzs": "Tanzanian Shilling",
        "uah": "Ukrainian Hryvnia",
        "ugx": "Ugandan Shilling",
        "uyu": "Uruguayan Peso",
        "uzs": "Uzbekistani Sum",
        "vnd": "Vietnamese Đồng",
        "vuv": "Vanuatu Vatu",
        "wst": "Samoan Tala",
        "xaf": "CFA Franc BEAC",
        "xcd": "East Caribbean Dollar",
        "xcg": "CEMAC CFA Franc (guaranteed convertible)",
        "xof": "CFA Franc BCEAO",
        "xpf": "CFP Franc",
        "yer": "Yemeni Rial",
        "zar": "South African Rand",
        "zmw": "Zambian Kwacha"
    };
    static ZERO_DECIMAL_CURRENCIES = ['bif','clp','djf','jpy','kmf','krw','mga','pyg','rwf','ugx','vnd','vuv','xaf','xof','xpf'];
    // NOTE: do 3-letter-code to symbol lookup

    static parse(str, currency){
        //console.log(str);
        //console.log(typeof str);
        if (!Object.keys(Currency.CURRENCIES).includes(currency)){
            return null;
        }
        if (Currency.ZERO_DECIMAL_CURRENCIES.includes(currency)){
            return Number(String(str).split(',').join(''));
        }
        //return Number(String(str).replaceAll(/[.,]/g, ''))
        const [p, d] = String(str).split('.');
        return Number(p)*100 + (d === undefined ? 0 : [0,Number(d)*10,Number(d)][d.length]);
    }
    static display(base_amount, currency){
        if (!Object.keys(Currency.CURRENCIES).includes(currency)){//(!(currency in Object.keys(Currency.CURRENCIES))){
            //console.log('returning null');
            //console.log(base_amount, currency);
            //console.log(Object.keys(Currency.CURRENCIES));
            return null;
        }
        if (Currency.ZERO_DECIMAL_CURRENCIES.includes(currency)){
            return String(base_amount).split('').reverse().map((e,i) => i % 3 === 2 ? ','+e : e).reverse().join('');
        } else {
            const str = String(base_amount / 100);
            return Number(str.split('.')[0]).toLocaleString() + '.' + (str.includes('.') ? str.split('.')[1] : '') + String(base_amount % 10 === 0 ? '0' : '') + String(base_amount % 100 === 0 ? '0' : '');
        }
    }
}

export default Currency;
